import React from "react";
import { useDispatch } from "react-redux";
import { useMsal } from "@azure/msal-react";
import { SkyDialog } from "@skypointcloud/skypoint-ui";
import { clearTokens } from "../../store/slices/authSlice";
import { logger } from "../../services/logger.service";

interface ErrorPageProps {
  show: boolean;
  message?: string;
  errorCode?: string;
  title?: string;
}

const ErrorPage = ({ show, message, errorCode, title }: ErrorPageProps): React.ReactElement => {
  const { instance } = useMsal();
  const dispatch = useDispatch();

  const backToLogin = (): void => {
    dispatch(clearTokens());
    instance.logoutRedirect().catch((error) => {
      logger.error("Logout failed", error);
    });
  };

  return (
    <SkyDialog
      open={show}
      onOpenChange={() => {}}
      title={title || "Error occurs!"}
      variant="modal"
      primaryAction={{ label: "Go to Login", onClick: backToLogin }}
    >
      <div className="form-group">
        {/* was Bootstrap's `.text-danger`, removed from skypointcloud.css
            because it shadowed the design system's own utility. */}
        {errorCode && <b className="text-destructive">Error Code: {errorCode}</b>}
      </div>
      <div className="form-group">
        <b>Message</b>
        <p>{message}</p>
      </div>
    </SkyDialog>
  );
};

export default ErrorPage;
